/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import AmrPanel from './layout';

import { compose } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import {
  userHasUpdatePermission,
  userHasPermissions,
  isEntityFetching,
  itemApiPending,
  getSelectedEntityId
} from '../../../redux/modules/entities/selectors';

import {
  getViewData,
  getProcessedViewData,
  getDisplayData,
  getDisplayDataRaw,
  getStatus,
  getArtifactFailedDeleted,
  getArtifactFailedLocked,
  getArtifactsProcessedCount,
  getInteractionsProcessedCount,
  getInteractionsRemainingCount,
  getErrorCount,
  getCurrentParentFormValues,
  getSelectableVersionList,
  isCreatingEntity,
 // handlePendingSubmit,
  onSubmitClick,
  selectTypesForDisplay,
  selectRequestTypesForDisplay,
  formTypeHasSubtypes,
  formSelectedRequestType,
  handleTermsSubmit,
  getSubmittedValues
}
// from '../../../redux/modules/entities/amr/selectors';
from '../../../redux/modules/entities/amr/selectors';
import { formSubmission, createFormName } from '../../../redux/modules/form/selectors';

import { setSelectedSubEntityId } from '../../../redux/modules/entities';
import { selectAlpsVersions } from '../../../redux/modules/entities/alps/selectors';
import { entitiesMetaData } from '../../../redux/modules/entities/metaData';

const ViewAmrForm = compose(
  connect(createFormName),
  reduxForm(),
   reduxForm({
     destroyOnUnmount: true,
   })
)(AmrPanel);

export function mapStateToProps(state) {
  return {
    initialValues: getDisplayDataRaw(state),
    displayValues: getDisplayData(state),
    //calculatedData: getDisplayData(state),
    sidePanelData:getProcessedViewData(state),
    statusRequestDetails:getStatus(state),
    artifactFilesDeleted:getArtifactFailedDeleted(state),
    artifactFailedLocked:getArtifactFailedLocked(state),
    artifactsProcessedCount:getArtifactsProcessedCount(state),
    interactionsProcessedCount:getInteractionsProcessedCount(state),
    interactionsRemainingCount:getInteractionsRemainingCount(state),
    errorCount:getErrorCount(state),
   // displayData:getDisplayData(state),
    key: getSelectedEntityId(state),
    artifactSubtypes: entitiesMetaData.alps.artifactSubtypes,

    userHasUpdatePermission: userHasUpdatePermission(state),
    userHasViewPermission: userHasPermissions(state, ['PLATFORM_VIEW_ALL']),
    alpFetching: isEntityFetching(state, 'amr'),
  //  versionsItems: selectAlpsVersions(state),
    itemApiPending: itemApiPending(state),
    submittedValues:getSubmittedValues(state)

  };
}

export const actions = {
  setSelectedSubEntityId,
};

export default connect(mapStateToProps, actions)(ViewAmrForm);
